import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import { Card, CardHeader, CardContent } from "@material-ui/core";
import ActionList from "./ActionList";

/**
 * @function useStyles
 * @description Hook for styling using Material-UI's makeStyles. Defines CSS styles for the actions card.
 * @param {Object} theme - Material-UI theme containing color, spacing, and other configurations
 * @memberof module:INTERTIDAL
 * @returns {Object} Object containing compiled CSS classes for component usage
 */
const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: 0,
    marginLeft: 12,
  },
  item: {
    margin: 0,
    padding: 0,
  },
  chip: {
    marginLeft: theme.spacing(1),
  },
}));

/**
 * @function ActionsCard
 * @description React component that wraps the intertidal ActionList in a titled card, rendered
 * only once the available image dates have loaded.
 * @param {Object} props - Component properties.
 * @param {string} [props.className] - Extra CSS class applied to the Card.
 * @see {@link ActionList}
 * **Called by:
 * @see {WaterlineIdentificationAndLevelAssigment}
 * @memberof module:INTERTIDAL
 * @returns {JSX.Element|null} The actions card, or null until availableDates has loaded.
 */
const ActionsCard = ({ className }) => {
  const availableDates = useSelector(
      (state) => state.acquisition.availableDates
  );
  const classes = useStyles();
  const [t] = useTranslation();

  return availableDates === undefined ? null : (
      <Card className={className} style={{ margin: 12 }}>
        <CardHeader title={t("forms.imageChooser.actions.title")} />
        <Divider />
        <CardContent className={classes.item}>
          <ActionList name="actions" />
        </CardContent>
      </Card>
  );
};

export default ActionsCard;
